import { plasticViewRoles } from '../../acciones-roles/departamentos/plastic-acciones-roles';
import { SideBarButton } from '../../nav-list/recursive-sidebar/class/sidebar';
import {
  PreConfigButton2,
  PreConfigButton3,
} from '../../nav-list/recursive-sidebar/configuration/preconfig';

export const PlasticRoutes: SideBarButton = {
  data: {
    name: 'Plasticos',
    appendUrl: './plastic',
    roles: plasticViewRoles.verDepartment,
  },
  options: PreConfigButton2,
  butons: [
    {
      data: {
        name: 'Maquinas',
        url: '/machine',
        roles: plasticViewRoles.verMaquinas,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Moldes',
        url: '/molds',
        otherUrls: ['/mold/:id'],
        roles: plasticViewRoles.verMoldes,
      },
      options: PreConfigButton3,
    },

    {
      data: {
        name: 'Inspeccion',
        url: '/inspection/cycle',
        otherUrls: [
          '/inspection/cycle',
          '/inspection/cut-order',
          '/inspection/detailed',
          '/inspection/cycle/:id',
          '/inspection/cut-order/:id',
          '/inspection/mold/:id',
          '/inspection/detailed/:id',
        ],
        roles: plasticViewRoles.verInspeccion,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Reportes de Scrap',
        url: '/reports',
        roles: plasticViewRoles.verInspeccion,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Imágenes de Scrap',
        url: '/scrap-images',
        roles: plasticViewRoles.verInspeccion,
      },
      options: PreConfigButton3,
    },

    {
      data: {
        name: 'Reporte Power BI',
        overWriteUrl: './reportsPBI/plastics',
        roles: plasticViewRoles.verPowerBI,
      },
      options: PreConfigButton3,
    },
  ],
};
